// extracted by mini-css-extract-plugin
export var fadeIn = "_fv-1";
export var modalContent = "_fv-3";
export var overlay = "_fv-0";
export var popoverContent = "_fv-2";
export var results = "_fv-5";
export var searchInputWrapper = "_fv-4";